import React from 'react';
import { Alert } from 'antd';

const AcceptedOfferAlert = () => (
    <Alert
        style={{ marginBottom: 10 }}
        message="Customer has accepted an offer and further valuations are disabled"
        type="warning"
        showIcon
    />
);

export default AcceptedOfferAlert;



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/Alerts/AcceptedOfferAlert.js